import React from "react"

/**
 * The `SidenavItem` component is used to display a single item in the sidenav.
 *
 * @example
 * ```html
 * <SidenavItem>
 *   <a href="#">Home</a>
 * </SidenavItem>
 *
 * <SidenavItem>
 *   <button>Foo</button>
 *   <SidenavSection subnav>
 *     <SidenavItem><a href="#">Nested Link</a></SidenavItem>
 *   </SidenavSection>
 * </SidenavItem>
 * ```
 */
export function SidenavItem({
  children,
  className,
  selected,
}: {
  /**
   * Should be a link or button without any classes or styles applied.
   */
  children: React.ReactNode
  className?: string
  /**
   * Whether the sidenav item is selected.
   */
  selected?: boolean
}) {
  const selectedProps = selected ? { selected: true } : {}
  return (
    <tds-sidenav-item class={className} {...selectedProps}>
      {children}
    </tds-sidenav-item>
  )
}
